export default function InductionCooker(props: any) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9728_20321)">
                <path
                    d="M27.5625 31.5H8.4375C7.50552 31.5 6.75 30.7445 6.75 29.8125V6.1875C6.75 5.25552 7.50552 4.5 8.4375 4.5H27.5625C28.4945 4.5 29.25 5.25552 29.25 6.1875V29.8125C29.25 30.7445 28.4945 31.5 27.5625 31.5Z"
                    stroke="black"
                    stroke-width="1.6875"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path d="M6.75 24.75H29.25" stroke="black" stroke-width="1.6875" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22.5 28.125H25.875" stroke="black" stroke-width="1.6875" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="1.125" cy="1.125" r="1.125" transform="matrix(1 0 0 -1 9 29.25)" fill="black" />
                <circle cx="1.125" cy="1.125" r="1.125" transform="matrix(1 0 0 -1 12.375 29.25)" fill="black" />
                <circle cx="1.125" cy="1.125" r="1.125" transform="matrix(1 0 0 -1 15.75 29.25)" fill="black" />
                <circle cx="6.75" cy="6.75" r="6.75" transform="matrix(1 0 0 -1 11.25 21.375)" stroke="black" stroke-width="1.6875" />
            </g>
            <defs>
                <clipPath id="clip0_9728_20321">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
